import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import './component.scss';
import {
  find,
  removeClass,
  elementValueIfEnabled,
  addClass,
} from '@fretadao/f-js-dom';
import axios from 'axios';

application.register('transporter-contact-form', class extends Controller {
  static targets = ['submitButton', 'form', 'fieldsPage', 'successPage'];

  successPageTargetConnected(target) {
    addClass(target, 'hidden');
  }

  submitForm(e) {
    e.preventDefault();

    addClass(this.submitButtonTarget, 'bt--disabled');
    this.makeSubmitRequest(this.retrieveFormInfo());
  }

  makeSubmitRequest(formData) {
    if(!formData) {
      removeClass(this.submitButtonTarget, 'bt--disabled');
      this.submitButtonTarget.text = 'Envie novamente';
      return;
    };

    axios
      .post(
        `${formData.url}`,
        formData.data
      )
      .then((res) => {
        addClass(this.fieldsPageTarget, 'hidden');
        removeClass(this.successPageTarget, 'hidden');
      })
      .catch((err) => {
        removeClass(this.submitButtonTarget, 'bt--disabled');
        this.submitButtonTarget.text = 'Envie novamente';
      })
  }

  retrieveFormInfo() {
    const form = this.formTarget;
    const formData = {
      contact: {
        name: this.getFieldValue('#contact_name'),
        phone: this.getFieldValue('#contact_phone'),
        email: this.getFieldValue('#contact_email'),
        description: this.getFieldValue('#contact_description'),
        utm_source: this.getFieldValue('#contact_utm_source'),
        utm_campaign: this.getFieldValue('#contact_utm_campaign'),
        utm_medium: this.getFieldValue('#contact_utm_medium'),
        gclid: this.getFieldValue('#contact_gclid')
      }
    };

    const check = [
      formData.contact.name,
      formData.contact.phone,
      formData.contact.description
    ];

    if(check.some(n => { return n === '' })) {
      return false;
    }

    return {
      data: formData,
      url: form.getAttribute('action')
    };
  }

  getFieldValue(fieldSelector) {
    const field = find(fieldSelector, this.formTarget);
    const fieldValue = elementValueIfEnabled(field);
    return fieldValue;
  }
})
